<template>
  <div
    class="m-banner" :class="extraItem.extras('banner.bannerType')"
    :style="{
      display: extraItem.extras('banner.display') == 1 ? 'block' : 'none',
    }"
  >
    <img v-if="!extraItem.extras('banner.bannerType') || extraItem.extras('banner.bannerType')=='wide'"
      :src="
        extraItem.extras('banner.src')
          ? extraItem.extras('banner.src')
          : ''
      "
      alt=""
    />
    <img v-if="extraItem.extras('banner.bannerType')=='narrow'"
      :src="
        extraItem.extras('banner.img')
          ? extraItem.extras('banner.img')
          : ''
      "
      alt=""
    />
  </div>
</template>

<script>
//import { cr } from "fire-wind-water";
//import { browerType } from "../common/sbase";
export default {
  props: ["extras"],
  data() {
    return {
//      imgInfor: {
//        banner:
//          browerType == "pc"
//            ? require("../assets/images/banner.png")
//            : require("../assets/images/banner-wap.png"),
//      },
    };
  },

  created() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
